import {Server} from '@fantasmagames/prototype/src/Server';
import {Communicator} from '@fantasmagames/slot/src/logic/Communicator';
import * as http from 'http';

export class PrototypeCommunicator extends Communicator {
	protected options: any = {
		host: '5.150.199.195',
		port: '4071',
		protocol: 'http:',
		path: '/simserver/Init?g=avalancheslot',
		method: 'GET',
		headers: {'content-type': 'application/json;charset=ISO-8859-1'},
	};

	protected gameID: string = 'avalancheslot';

	protected _fakeResponses: string[] = [];

	api_autoPlayStarted(...args: any[]): void {}

	api_autoPlayStopped(...args: any[]): void {}

	api_balanceUpdate(...args: any[]): void {}

	api_betSizeUpdate(...args: any[]): void {}

	api_gameRoundCompleted(...args: any[]): void {}

	api_gameSetMute(...args: any[]): void {}

	api_gamemenuClosed(...args: any[]): void {}

	api_gamemenuOpen(...args: any[]): void {}

	api_gameplayPause(...args: any[]): void {}

	api_gameplayStart(...args: any[]): void {}

	api_playerInformationRecieved(...args: any[]): void {}

	api_showErrorMessage(...args: any[]): void {}

	api_winUpdate(...args: any[]): void {}

	freeSpin(...args: any[]): void {}

	pick(...args: any[]): void {}

	ping(...args: any[]): void {}

	requestSavedData(...args: any[]): void {}

	saveData(...args: any[]): void {}

	skippick(...args: any[]): void {}

	protected _server: Server;

	constructor() {
		super();

		this._server = new Server();

		if (!__PRODUCTION__) {
			(window as any).cheatAdditionalData = '';
			(window as any).fake = this;
		}
	}

	public addFakeResponse(response: string): void {
		this._fakeResponses.push(response);
	}

	public init(gameID: string, callback: Function): void {
		this.sendRequest(``, callback);
	}

	public spin(sid: string, bet: number, callback: Function): void {
		if (this._fakeResponses.length > 0) {
			setTimeout(() => {
				callback(this._fakeResponses[0]);
				this._fakeResponses.splice(0, 1);
			}, 100);
		} else {
			this.options.path = `/simserver/Spin?g=${this.gameID}&ba=${bet}&sid=${sid}`;
			this.addCheatToSpin();
			this.sendRequest(``, callback);
		}
	}

	protected addCheatToSpin(): void {}

	public freespin(...args: any[]): void {}

	public initFeatures(featureIndexes: number[], callback: Function): void {
		setTimeout(() => {
			this._server.init(featureIndexes);
			callback();
		}, 0);
	}

	public play(gameID: string, sessID: string, chanel: string, language: string, currency: string, callback: Function): void {
		setTimeout(() => {
			this._server.spin();
			const fsRounds: JSON[] = this._server.hasMimicFSRounds() ? this._server.getCurrentMimicFS() : this._server.getCurrentFS();
			callback(this._server.getCurrentRoundResult(), fsRounds);
		}, 0);
	}

	public avalanche(...args: any[]): void {}

	public respin(...args: any[]): void {}

	public sendRequest(writeString: string, callback: Function): void {
		const cb = (response) => {
			let str = '';
			response.on('data', (chunk) => {
				str += chunk;
			});

			response.on('end', () => {
				// console.log(str);
				callback(str);
			});
		};

		const req = http.request(this.options, cb);

		req.write(writeString);

		req.end();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/prototype/PrototypeCommunicator.ts